import { render } from "./about-us.vue?vue&type=template&id=4a32c9a6"
import script from "./about-us.vue?vue&type=script&lang=js"
export * from "./about-us.vue?vue&type=script&lang=js"
script.render = render

export default script